import React from 'react';

import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Page from 'marketing-website/components/modules/Page';

import metaData from 'marketing-website/data/metadata.js';
import data from 'marketing-website/configs/pages/examples/data';

import styles from './style/general.module.css';

import Card from './_Card';

export default function Examples() {
  return (
    <Page
      title={metaData.examples.title}
      meta={[
        {
          name: 'description',
          content: metaData.examples.description,
        },
      ]}
      banner
      header
      footer
    >
      <div className="overflow-hidden">
        <div className={styles.wrap}>
          <h1 className={styles.heading}>Example Prototypes</h1>
          <Spacing size="l" type="padding" position="bottom">
            <MaxWidth value={720}>
              <p className={styles.subheading}>
                Discover the endless possibilities of building prototypes in
                Marvel. Click an example to see it in action.
              </p>
            </MaxWidth>
          </Spacing>
          <div className={styles.grid}>
            {data.map(example => (
              <Card
                key={example.url}
                title={example.name}
                description={example.description}
                previewImage={example.previewImage}
                path={example.path}
                tags={example.tags}
              />
            ))}
          </div>
        </div>
      </div>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/examples/index.js